'use client'

import { type ReactNode, createContext, useRef, useContext } from 'react'
import { useStore } from 'zustand'
import { type DrawerStore, createDrawerStore } from '@/stores/drawer-store'
import { NotificationCreateDrawer } from '@/components/notification-create-drawer'

export type DrawerStoreApi = ReturnType<typeof createDrawerStore>

export const DrawerStoreContext = createContext<DrawerStoreApi | undefined>(
  undefined,
)

export interface DrawerStoreProviderProps {
  children: ReactNode
}

export const DrawerStoreProvider = ({ children }: DrawerStoreProviderProps) => {
  const storeRef = useRef<DrawerStoreApi | null>(null)
  if (storeRef.current === null) {
    storeRef.current = createDrawerStore()
  }

  return (
    <DrawerStoreContext.Provider value={storeRef.current}>
      {children}
      <NotificationCreateDrawer />
    </DrawerStoreContext.Provider>
  )
}

export const useDrawerStore = <T,>(selector: (store: DrawerStore) => T): T => {
  const drawerStoreContext = useContext(DrawerStoreContext)

  if (!drawerStoreContext) {
    throw new Error(`useDrawerStore must be used within DrawerStoreProvider`)
  }

  return useStore(drawerStoreContext, selector)
}
